import { useState, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { styled } from '@material-ui/core/styles';
import {
  Box,
} from '@material-ui/core';

import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CircleIcon from '@material-ui/icons/Circle';

import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';

import PopupNotifContext from "../contexts/PopupNotifContext"

const DashboardLayoutRoot = styled('div')(
  ({ theme }) => ({
    backgroundColor: 'theme.palette.background.default',
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%',
    fontFamily: 'Roboto Flex',
  })
);

const DashboardLayoutWrapper = styled('div')(
  ({ theme }) => ({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64,
    /*[theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }*/
  })
);

const DashboardLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = styled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto'
});

const DashboardLayout = ( {children} ) => {
  const [isMobileNavOpen, setMobileNavOpen] = useState(false);

  const { notifs, haveToDisplay, removeByUUID } = useContext(PopupNotifContext)

  return (
    <DashboardLayoutRoot>
      {haveToDisplay !== null &&
        <Box
          sx={{
            position:"absolute",
            top:["30px", "unset", "unset"],
            bottom:["unset", "15px", "15px"],
            left:["15px", "25px", "25px"],
            width:["calc(100% - 30px)", "calc(100% - 50px)", "calc(100% - 50px)"],
            zIndex:99999999,
            display:"flex",
            justifyContent:["center", "center", "flex-end"],
            userSelect:"none",
            cursor:"pointer",
          }}
          onClick={() => {
            removeByUUID(haveToDisplay?.uuid)
          }}
        >
          <Box sx={{
            background:"white",
            border:"1px solid #E7E7E7",
            fontWeight:500,
            fontSize:["13px", "14px", "15px"],
            color:"text.black",
            textAlign:"center",
            boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.1)",
            padding:"10px",
            display:"flex",
            alignItems:"center",
            gap:"5px",
          }}>
            {haveToDisplay?.type === "confirmation" &&
              <CheckCircleIcon sx={{
                color:"#38B000",
                width:"16px",
                height:"16px",
              }}/>
            }
            {haveToDisplay?.type === "error" &&
              <CircleIcon sx={{
                color:"#E24C4B",
                width:"16px",
                height:"16px",
              }}/>
            }
            {haveToDisplay?.text}
          </Box>
        </Box>
      }
      <DashboardNavbar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <DashboardSidebar
        onMobileClose={() => setMobileNavOpen(false)}
        openMobile={isMobileNavOpen}
      />
      <DashboardLayoutWrapper>
        <DashboardLayoutContainer>
          <DashboardLayoutContent>
            {children}
          </DashboardLayoutContent>
        </DashboardLayoutContainer>
      </DashboardLayoutWrapper>
    </DashboardLayoutRoot>
  );
};

export default DashboardLayout;
